import {Column, HeaderProps} from 'react-table'
import {IDLRList} from './_model'
import SelectionHeader from '../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../utils/components/table-content/SelectionCell'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../utils/components/table-content/CustomHeader'
import {KTIcon} from '../../../_metronic/helpers'

const dlrListTableColumn = (
  handleSelect: (selectType: string, id: number) => void
): ReadonlyArray<Column<IDLRList>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IDLRList>>) => (
      <CustomHeader tableProps={props} title='Username' className='min-w-100px' />
    ),
    id: 'userName',
    accessor: 'userName',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IDLRList>>) => (
      <CustomHeader tableProps={props} title='success url' className='min-w-100px' />
    ),
    id: 'successUrl',
    accessor: 'successUrl',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IDLRList>>) => (
      <CustomHeader tableProps={props} title='failed url' className='min-w-100px' />
    ),
    id: 'faildUrl',
    accessor: 'faildUrl',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IDLRList>>) => (
      <CustomHeader tableProps={props} title='status' className='min-w-100px' />
    ),
    id: 'status',
    Cell: ({...props}) => (
      <div>
        <p className='badge badge-light-primary'>
          {/* {props.data[props.row.index].status === '1'
            ? 'Active'
            : props.data[props.row.index].status === '2'
            ? 'Pause'
            : 'Deactive'} */}
          {props.data[props.row.index].status}
        </p>
      </div>
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<IDLRList>>) => (
      <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <div className='text-end'>
        <button
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
          data-bs-toggle='modal'
          data-bs-target='#kt_modal_1'
          onClick={() => handleSelect('edit', props.data[props.row.index].id)}
        >
          <KTIcon iconName='pencil' className='fs-3' />
        </button>
      </div>
    ),
  },
]

export default dlrListTableColumn
